// src/components/Rewards/data.js
// Static mock data for JMI Seller Rewards

export const sellerData = {
  name: 'Ranjeet Jewellers',
  level: 'Diamond',
  nextLevel: 'Elite',
  jpBalance: 58420,
  jpTarget: 100000,
  jpToNext: 41580,
  trustScore: 97,
};

export const performanceMetrics = {
  sales: { value: '₹2.84 Cr', change: '+42%', trend: 'up' },
  orders: { value: '642', change: '+31%', trend: 'up' },
  growth: { value: '+42%', change: '+8pp', trend: 'up' },
  trust: { value: '97/100', change: '+2', trend: 'up' },
  mini: [
    { label: 'On-Time Dispatch', value: '98%', color: '#22c55e' },
    { label: 'Repeat Buyers', value: '74', color: '#3b82f6' },
    { label: 'Approved Products', value: '486', color: '#f59e0b' },
  ],
};

export const nextMilestone = {
  goal: '1,000 Completed Orders',
  current: 642,
  target: 1000,
  reward: 'Professional Photography Setup',
  emoji: '📸',
};

export const rewardCategories = [
  {
    id: 'photography',
    icon: '📸',
    color: '#fef3c7',
    label: 'Photography',
    desc: 'Create professional jewellery product images for your JMI catalogue.',
    rewards: [
      'Photography Light Box', 'LED Lighting Kit', 'Ring Light', 'Jewellery Display Stand',
      'Rotating Display', 'Macro Lens', 'Smartphone Tripod', 'Background Sheets',
      'Photography Table', 'Professional Photography Setup', 'Jewellery Photography Service',
    ],
  },
  {
    id: 'testing',
    icon: '🔬',
    color: '#dbeafe',
    label: 'Testing & Quality',
    desc: 'Improve product verification and quality control.',
    rewards: [
      'Precision Digital Scale', 'Jewellery Loupe', "Jeweller's Microscope", 'Diamond Loupe',
      'UV Inspection Light', 'Vernier Caliper', 'Gold Testing Accessories', 'Gemstone ID Tools',
      'Diamond Screening Equipment', 'Purity Testing Support', 'Professional Testing Equipment',
    ],
  },
  {
    id: 'packaging',
    icon: '📦',
    color: '#fce7f3',
    label: 'Packaging & Dispatch',
    desc: 'Build a faster and more professional dispatch operation.',
    rewards: [
      'Jewellery Boxes', 'Pouches', 'Shipping Boxes', 'Tamper-Proof Bags', 'Barcode Labels',
      'Label Printer', 'Thermal Printer', 'Packaging Stickers', 'Dispatch Bags', 'Packing Station',
    ],
  },
  {
    id: 'catalogue',
    icon: '📋',
    color: '#f0fdf4',
    label: 'Catalogue & Listing',
    desc: 'Turn your inventory into a professional digital catalogue.',
    rewards: [
      'Product Photography', 'Background Removal', 'Catalogue Creation', 'Product Videos',
      'Measurement Cards', 'Barcode/QR System', 'Product Labels', 'Digital Catalogue',
      'Bulk Product Upload', 'Product Data Entry',
    ],
  },
  {
    id: 'workshop',
    icon: '🔧',
    color: '#fef9ec',
    label: 'Production & Workshop',
    desc: 'Improve workshop productivity and accuracy.',
    rewards: [
      'Precision Measuring Tools', 'Digital Caliper', 'Micrometer', 'Bench Tools',
      'Workbench Accessories', 'Magnifying Equipment', 'Polishing Accessories',
      'Workshop Equipment', 'Safety Equipment', 'Tool Cabinet', 'Machinery Support',
    ],
  },
  {
    id: 'inventory',
    icon: '🗄️',
    color: '#f5f3ff',
    label: 'Inventory & Storage',
    desc: 'Organise and digitise your entire jewellery inventory.',
    rewards: [
      'Jewellery Trays', 'Product Organizers', 'Storage Boxes', 'Barcode Scanner',
      'Barcode Printer', 'Inventory Tagging Kit', 'RFID Support', 'Storage Cabinet', 'Inventory Software',
    ],
  },
  {
    id: 'marketing',
    icon: '📣',
    color: '#fff1f2',
    label: 'Marketing',
    desc: 'Build your brand and reach more buyers.',
    rewards: [
      'Product Photography', 'Social Media Creatives', 'Festival Campaign', 'Product Videos',
      'Catalogue Design', 'Brochure', 'Seller Branding', 'WhatsApp Catalogue',
      'Social Media Management', 'Local Marketing',
    ],
  },
  {
    id: 'advertising',
    icon: '📢',
    color: '#ecfdf5',
    label: 'Advertising',
    desc: 'Amplify reach through paid media and JMI campaigns.',
    rewards: [
      'Meta Ads Budget', 'Google Ads Budget', 'YouTube Promotion', 'Influencer Promotion',
      'Local Advertising', 'Festival Advertising', 'JMI Campaign Support', 'JMI Management Support',
    ],
  },
  {
    id: 'visibility',
    icon: '⭐',
    color: '#fffbeb',
    label: 'JMI Marketplace Visibility',
    desc: 'Priority placement across JMI marketplace surfaces.',
    rewards: [
      'Featured Seller', 'Featured Products', 'New Arrivals Priority', 'Trending Placement',
      'Festival Collection', 'Premium Collection', 'Recommended Seller', 'Priority Catalogue Visibility',
    ],
  },
];

export const featuredReward = {
  title: 'Professional Jewellery Photography Setup',
  emoji: '📸',
  gates: [
    { label: '500 Orders', type: 'orders' },
    { label: 'Platinum Level', type: 'level' },
    { label: 'Trust Score 90+', type: 'trust' },
  ],
  includes: [
    'Photography light & softbox',
    'Jewellery display stand',
    'White & black background setup',
    'Adjustable tripod',
    'Rotating turntable',
  ],
  marketValue: 22000,
  jmiSupport: 15000,
  sellerContribution: 7000,
};

export const milestones = {
  orders: [
    { label: 'First Sale', status: 'done', reward: 'JMI Starter Pack' },
    { label: '10 Orders', status: 'done', reward: 'Barcode Labels' },
    { label: '25 Orders', status: 'done', reward: 'Photography Light Box' },
    { label: '50 Orders', status: 'done', reward: 'Jewellery Loupe' },
    { label: '100 Orders', status: 'done', reward: 'Packaging Bundle' },
    { label: '250 Orders', status: 'current', reward: 'Ring Light + Stand', progress: 64 },
    { label: '500 Orders', status: 'locked', reward: 'Product Photography Session' },
    { label: '1,000 Orders', status: 'locked', reward: 'Professional Photography Setup' },
  ],
  products: [
    { label: '10 Approved Products', status: 'done', reward: 'Digital Catalogue' },
    { label: '50 Approved Products', status: 'done', reward: 'Barcode Scanner' },
    { label: '100 Approved Products', status: 'current', reward: 'Product Photography', progress: 76 },
    { label: '250 Approved Products', status: 'locked', reward: 'Catalogue Design' },
    { label: '500 Approved Products', status: 'locked', reward: 'Digital Cataloguing Support' },
  ],
};

export const trustMetrics = [
  { label: 'Product Accuracy', value: 99, type: 'excellent' },
  { label: 'Weight Accuracy', value: 98, type: 'excellent' },
  { label: 'Purity Accuracy', value: 99, type: 'excellent' },
  { label: 'Price Accuracy', value: 97, type: 'excellent' },
  { label: 'On-Time Dispatch', value: 98, type: 'excellent' },
  { label: 'Cancellation Rate', value: 1.2, type: 'warning', inverse: true },
  { label: 'Dispute Rate', value: 0.4, type: 'warning', inverse: true },
];

export const leagueCategories = [
  { label: 'Sales Champion', active: false },
  { label: 'Order Champion', active: true },
  { label: 'Speed Champion', active: true },
  { label: 'Quality Champion', active: false },
  { label: 'Growth Champion', active: true },
  { label: 'Buyer Loyalty', active: false },
  { label: 'Rising Seller', active: false },
];

export const growthStats = [
  { label: 'Sales', value: '₹2.84 Cr', change: '+42%' },
  { label: 'Orders', value: '642', change: '+31%' },
  { label: 'Approved Products', value: '486', change: '+24%' },
  { label: 'Repeat Buyers', value: '74', change: '+18%' },
  { label: 'Dispatch Rate', value: '98%', change: '+3pp' },
  { label: 'Catalogue Growth', value: '+112', change: '+29%' },
];

export const achievements = [
  { name: 'First Sale', emoji: '🏆', earned: true, bg: '#fef3c7' },
  { name: '100 Orders', emoji: '📦', earned: true, bg: '#dbeafe' },
  { name: 'Fast Dispatcher', emoji: '⚡', earned: true, bg: '#fce7f3' },
  { name: 'Quality Seller', emoji: '✅', earned: true, bg: '#f0fdf4' },
  { name: 'Diamond Seller', emoji: '💎', earned: true, bg: '#f5f3ff' },
  { name: 'Repeat Builder', emoji: '🔄', earned: true, bg: '#ecfdf5' },
  { name: 'Growth Champion', emoji: '📈', earned: false, bg: '#fff1f2' },
  { name: 'Featured Seller', emoji: '⭐', earned: false, bg: '#fffbeb' },
  { name: 'Rising Seller', emoji: '🚀', earned: false, bg: '#f0f9ff' },
  { name: 'Brand Builder', emoji: '🎨', earned: false, bg: '#fef3c7' },
  { name: 'Catalogue Builder', emoji: '📋', earned: false, bg: '#dbeafe' },
  { name: 'Trusted Seller', emoji: '🛡️', earned: false, bg: '#fce7f3' },
];

export const equipmentItems = [
  { name: 'Digital Precision Scale', emoji: '⚖️', bg: '#fef3c7', market: 8000, support: 4000, contribution: 4000 },
  { name: 'Professional Light Box', emoji: '💡', bg: '#dbeafe', market: 6500, support: 4000, contribution: 2500 },
  { name: 'Jeweller\'s Microscope', emoji: '🔬', bg: '#f0fdf4', market: 12000, support: 7000, contribution: 5000 },
  { name: 'Thermal Label Printer', emoji: '🖨️', bg: '#f5f3ff', market: 9000, support: 5000, contribution: 4000 },
  { name: 'Barcode Scanner', emoji: '📲', bg: '#fce7f3', market: 3500, support: 2000, contribution: 1500 },
  { name: 'Precision Caliper Set', emoji: '📏', bg: '#fffbeb', market: 5000, support: 3000, contribution: 2000 },
];

export const walletItems = {
  available: [
    { name: 'Photography Light Box', emoji: '💡', req: '25 Orders Complete', date: 'Unlocked Sep 1, 2026', status: 'available' },
    { name: 'Ring Light + Stand', emoji: '🔦', req: '250 Orders Complete', date: 'Unlocked Sep 2, 2026', status: 'available' },
  ],
  unlocked: [
    { name: 'Jewellery Display Stand', emoji: '🪞', req: '100 Orders Complete', date: 'Unlocked Aug 18, 2026', status: 'unlocked' },
    { name: 'Barcode Labels Bundle', emoji: '🏷️', req: '50 Orders Complete', date: 'Unlocked Aug 5, 2026', status: 'unlocked' },
  ],
  pending: [
    { name: 'Precision Digital Scale', emoji: '⚖️', req: 'Equipment Support Application', date: 'Applied Aug 30, 2026', status: 'pending' },
  ],
};

export const pointHistory = [
  { type: 'credit', emoji: '📦', desc: 'Completed Order #JMI-8842', sub: 'Ready Stock', jp: 100, date: 'Today, 10:32 AM' },
  { type: 'credit', emoji: '⚡', desc: 'On-Time Dispatch Bonus', sub: 'Order #JMI-8842', jp: 75, date: 'Today, 10:32 AM' },
  { type: 'credit', emoji: '✅', desc: 'Product Approved by QC', sub: 'Gold Necklace Set', jp: 50, date: 'Yesterday, 2:14 PM' },
  { type: 'credit', emoji: '🔄', desc: 'Repeat Buyer Order', sub: 'Buyer: Suresh Traders', jp: 150, date: 'Yesterday, 9:05 AM' },
  { type: 'credit', emoji: '📈', desc: 'Monthly Growth Milestone', sub: '+42% sales growth', jp: 500, date: 'Sep 1, 2026' },
  { type: 'debit', emoji: '❌', desc: 'Cancelled Order Reversal', sub: 'Order #JMI-8710', jp: -100, date: 'Aug 30, 2026' },
  { type: 'credit', emoji: '📦', desc: 'Completed Order #JMI-8700', sub: 'Order Serve', jp: 100, date: 'Aug 29, 2026' },
  { type: 'credit', emoji: '🏷️', desc: 'Bulk Product Upload Bonus', sub: '12 products approved', jp: 200, date: 'Aug 28, 2026' },
];

export const clubBenefits = [
  'Premium marketplace visibility',
  'Priority seller support',
  'Equipment support access',
  'Photography support sessions',
  'Testing equipment support',
  'Marketing campaign credits',
  'Advertising budget support',
  'Technology support access',
  'Exclusive seller events',
  'Annual seller awards',
  'Business networking',
  'Business travel opportunities',
];
